// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.legend-container {
  display: flex;
  /* box-shadow: rgb(0 0 0 / 10%) 2px -1px 4px !important; */
  /* grid-template-columns: repeat(2, 2fr); */
  padding: 10px 5px 10px 30px;
  justify-content: center;
  border-radius: 4px;
}

.legend-entry-container {
  /* width: 100%; */
  align-items: center;
  display: flex;
  justify-content: left;
  font-size: 0.8rem;
  margin-right: 20px;
}

.p-9 {
  padding: 0 9px;
}

.legend-hr {
  margin-left: 0;
  margin-right: 0;
  border-radius: 3px !important;
  opacity: 100 !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/homeDashboard/components/TableLegend/TableLegend.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0DAA0D;EAC1D,2CAA2C;EAC3C,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,6BAA6B;EAC7B,uBAAuB;AACzB","sourcesContent":[".legend-container {\n  display: flex;\n  /* box-shadow: rgb(0 0 0 / 10%) 2px -1px 4px !important; */\n  /* grid-template-columns: repeat(2, 2fr); */\n  padding: 10px 5px 10px 30px;\n  justify-content: center;\n  border-radius: 4px;\n}\n\n.legend-entry-container {\n  /* width: 100%; */\n  align-items: center;\n  display: flex;\n  justify-content: left;\n  font-size: 0.8rem;\n  margin-right: 20px;\n}\n\n.p-9 {\n  padding: 0 9px;\n}\n\n.legend-hr {\n  margin-left: 0;\n  margin-right: 0;\n  border-radius: 3px !important;\n  opacity: 100 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
